import createIcon from '../../createIcon';

/**
 * @component @name GolfCourse
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMjFDMTkuODI4NCAyMSAyMC41IDIwLjMyODQgMjAuNSAxOS41QzIwLjUgMTguNjcxNiAxOS44Mjg0IDE4IDE5IDE4QzE4LjE3MTYgMTggMTcuNSAxOC42NzE2IDE3LjUgMTkuNUMxNy41IDIwLjMyODQgMTguMTcxNiAyMSAxOSAyMVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNi41IDUuOTJMOC41IDJWMjBINi41VjE4LjI3QzQuNzEgMTguNjIgMy41IDE5LjI2IDMuNSAyMEMzLjUgMjEuMSA2LjE5IDIyIDkuNSAyMkMxMi44MSAyMiAxNS41IDIxLjEgMTUuNSAyMEMxNS41IDE5LjAxIDEzLjM0IDE4LjE5IDEwLjUgMTguMDNWOC45OEwxNi41IDUuOTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GolfCourse = createIcon('GolfCourse', [
  [
    'path',
    {
      d: 'M19 21C19.8284 21 20.5 20.3284 20.5 19.5C20.5 18.6716 19.8284 18 19 18C18.1716 18 17.5 18.6716 17.5 19.5C17.5 20.3284 18.1716 21 19 21Z',
      key: 'kzasza',
    },
  ],
  [
    'path',
    {
      d: 'M16.5 5.92L8.5 2V20H6.5V18.27C4.71 18.62 3.5 19.26 3.5 20C3.5 21.1 6.19 22 9.5 22C12.81 22 15.5 21.1 15.5 20C15.5 19.01 13.34 18.19 10.5 18.03V8.98L16.5 5.92Z',
      key: 'rq3w93',
    },
  ],
]);

export default GolfCourse;
